import React, { Component } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TracksPopularLastWeek from "~/Components/Elements/TracksPopularLastWeek";
import TracksPopularLastWeekContainer from "~/Containers/TracksPopularLastWeekContainer";
import ArtistBanner from "../Artist/ArtistBanner";

const MessageBoardFooter = () => {

  const artists = [
    "Brian Eno",
    "Fleetwood Mac",
    "Steely Dan",
    "David Bowie",
    "Radiohead",
    "The Beatles",
    "Pink Floyd",
    "Miles Davis",
    "Kraftwerk",
    "Tangerine Dream",
    "Can",
    "Michael Rother",
    "Hiss Golden Messenger",
    "The Beach Boys",
    "Neil Young",
    "Paul McCartney",
    "Sun Ra",
    "Sonic Youth",
    "Ashra",
    "Herbie Hancock",
    "James Brown",
    "George Harrison",
    "Wilco",
    "John Martyn"
  ];
  const randomIndex = Math.floor(Math.random() * artists.length);

  // Return the element at the random index


  return (
    <Row className="mb-footer">
      <Col xs={12}>
        <TracksPopularLastWeekContainer
          render={(props) => {
            return <TracksPopularLastWeek {...props} />;
          }}
        />
      </Col>
      {/* <ArtistBanner artistSlug={artists[randomIndex]} title="Records you might need..." /> */}
      <Col xs={12} sm={12} md={6}>
        <div className="totd-header dark mb">
          <h4>Message Board Options</h4>
        </div>

        <ul className="mb-footer-links">
          <li>
            <Link to="/message-board/new">Add a new Topic</Link>
            <p>Anyone can add to the Message Board.</p>
          </li>
          <li>
            <Link to="/message-board/today">Today's Messages</Link>
            <p>Read the most recent messages.</p>
          </li>
        </ul>
      </Col>
      <Col xs={12} sm={12} md={6}>
        <div className="totd-header dark mb">
          <h4>Also on Dream Chimney</h4>
        </div>
        <ul className="mb-footer-links">

          <li>
            <a href="/interviews/" target="_blank">
              Interviews
            </a>
            <p>A friendly chimneyside chat with those in music world that interest us the most. </p>
          </li>
          <li>
            <a href="/motw/" target="_blank">
              Mix of the Week
            </a>
            <p>Weekly music mixes.</p>
          </li>
          <li>
            <a href="/sleevery/" target="_blank">
              Sleevery
            </a>
            <p>the classiest record cover sleeves we've ever seen.</p>
          </li>
        </ul>
      </Col>
    </Row>
  );

}

export default MessageBoardFooter;
